export const onboardingSteps = {
  admin: [
    {
      selector: '[data-section="dashboard"]',
      title: 'Welcome to Your Dashboard',
      description: 'Your command center for managing client organizations, brands, and team activity.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'dashboard'
    },
    {
      selector: '[data-section="admin-organizations-brands"]',
      title: 'Organization Management',
      description: 'Your primary responsibility - managing client organizations and brands.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'admin-organizations-brands'
    },
    {
      selector: '[data-onboarding="create-org-tab"]',
      title: 'Create Organization',
      description: 'Create new client organizations here. Each client gets their own organization.',
      position: 'bottom',
      highlightPadding: 6,
      requiredSection: 'admin-organizations-brands'
    },
    {
      selector: '[data-onboarding="create-brand-tab"]',
      title: 'Create Brand',
      description: 'Add brands to organizations. Each organization can have multiple brands with unique identities.',
      position: 'bottom',
      highlightPadding: 6,
      requiredSection: 'admin-organizations-brands'
    },
    {
      selector: '[data-onboarding="assign-edit-tab"]',
      title: 'Assign & Edit',
      description: 'Assign operators and clients to organizations and brands, and edit existing setups.',
      position: 'bottom',
      highlightPadding: 6,
      requiredSection: 'admin-organizations-brands'
    },
    {
      selector: '[data-section="agency-hub"]',
      title: 'Agency Hub',
      description: 'Access agency-wide settings and database management tools.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'agency-hub'
    },
    {
      selector: '[data-onboarding="database-backups-tab"]',
      title: 'Database Backups',
      description: 'Manage and restore database backups to protect your agency data.',
      position: 'bottom',
      highlightPadding: 6,
      requiredSection: 'agency-hub'
    },
    {
      selector: '[data-section="admin"], [data-section="super-admin"]',
      title: 'Admin Menu',
      description: 'Access admin-specific tools for managing users and monitoring activity.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: null,
      expandAccordion: true
    },
    {
      selector: '[data-section="admin-user-management"]',
      title: 'User Management',
      description: 'Manage invitations, user hierarchy, and users in your agency.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'admin-user-management',
      parentAccordion: '[data-section="admin"], [data-section="super-admin"]'
    },
    {
      selector: '[data-onboarding="invitations-tab"]',
      title: 'Invitations',
      description: 'Send invitations to new operators and clients to join your agency.',
      position: 'bottom',
      highlightPadding: 6,
      requiredSection: 'admin-user-management',
      parentAccordion: '[data-section="admin"], [data-section="super-admin"]'
    },
    {
      selector: '[data-onboarding="user-hierarchy-tab"]',
      title: 'Agency User Hierarchy',
      description: 'View and manage your agency\'s user structure and relationships.',
      position: 'bottom',
      highlightPadding: 6,
      requiredSection: 'admin-user-management',
      parentAccordion: '[data-section="admin"], [data-section="super-admin"]'
    },
    {
      selector: '[data-onboarding="management-tab"]',
      title: 'Management',
      description: 'Manage user roles, permissions, and account settings.',
      position: 'bottom',
      highlightPadding: 6,
      requiredSection: 'admin-user-management',
      parentAccordion: '[data-section="admin"], [data-section="super-admin"]'
    },
    {
      selector: '[data-section="proxy-user"]',
      title: 'Proxy User',
      description: 'Access the system as another user for support and troubleshooting purposes.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'proxy-user',
      parentAccordion: '[data-section="admin"], [data-section="super-admin"]'
    },
    {
      selector: '[data-section="activity-log"]',
      title: 'Activity Logs',
      description: 'Monitor operator and client activity across your agency to track usage and performance.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'activity-log',
      parentAccordion: '[data-section="admin"], [data-section="super-admin"]'
    },
    {
      selector: '[data-onboarding="org-brand-selector"]',
      title: 'Organization & Brand Selector',
      description: 'Click here to switch between client organizations and brands. This changes all data context - everything is organization and brand-specific.',
      position: 'right',
      highlightPadding: 6,
      requiredSection: null
    },
    {
      selector: '.nav-user-profile',
      title: 'Profile & Settings',
      description: 'Access your account settings, notifications, and restart this onboarding tour anytime.',
      position: 'right',
      highlightPadding: 6,
      disableLeftBackdrop: true,
      noLeftOffset: true,
      requiredSection: null
    }
  ],

  operator: [
    {
      selector: '[data-section="dashboard"]',
      title: 'Your Operator Dashboard',
      description: 'Your workspace for tracking assigned clients and content tasks. See what needs your attention today.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'dashboard'
    },
    {
      selector: '[data-section="todo"]',
      title: 'To Do List',
      description: 'Your daily task list - see what content needs to be created, reviewed, or scheduled.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'todo'
    },
    {
      selector: '[data-onboarding="org-brand-selector"]',
      title: 'Organization & Brand Selector',
      description: 'Click here to switch between your assigned client organizations and brands. Each selection changes which content you\'re working on.',
      position: 'right',
      highlightPadding: 6,
      requiredSection: null
    },
    {
      selector: '[data-section="sources-menu"]',
      title: 'Your Content Sources',
      description: 'Your raw materials for content creation. This is where you upload and manage all source content.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: null,
      expandAccordion: true
    },
    {
      selector: '[data-section="sources"]',
      title: 'Manage Sources',
      description: 'Upload podcasts, videos, documents, and meeting recordings. These become the foundation for your content ideas.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'sources',
      parentAccordion: '[data-section="sources-menu"]'
    },
    {
      selector: '[data-section="recordings"]',
      title: 'Squadcast Integration',
      description: 'Import podcast episodes directly from Squadcast to use as content sources.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'recordings',
      parentAccordion: '[data-section="sources-menu"]'
    },
    {
      selector: '[data-section="ideas"]',
      title: 'Content Ideas',
      description: 'Transform your sources into content ideas. This is where the creative process begins.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: null,
      expandAccordion: true
    },
    {
      selector: '[data-section="create-ideas"]',
      title: 'Create Ideas',
      description: 'Generate new content ideas from your sources. Turn raw material into actionable content topics.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'create-ideas',
      parentAccordion: '[data-section="ideas"]'
    },
    {
      selector: '[data-section="operator-review-ideas"]',
      title: 'Review Ideas',
      description: 'Manage and refine your content ideas before turning them into finished content.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'operator-review-ideas',
      parentAccordion: '[data-section="ideas"]'
    },
    {
      selector: '[data-section="content"]',
      title: 'Content Management',
      description: 'Create and manage content for your clients. This is your main content workflow hub.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: null,
      expandAccordion: true
    },
    {
      selector: '[data-section="create"]',
      title: 'Create Content',
      description: 'Draft new content from your ideas. Write, refine, and polish content for client approval.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'create',
      parentAccordion: '[data-section="content"]'
    },
    {
      selector: '[data-section="review-content"]',
      title: 'Review Content',
      description: 'Manage drafts and send content for client approval. This is the "ping pong" - back and forth with clients!',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'review-content',
      parentAccordion: '[data-section="content"]'
    },
    {
      selector: '[data-section="schedule-posts"]',
      title: 'Schedule',
      description: 'Schedule approved content for publishing. Set dates and times for content to go live.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'schedule-posts'
    },
    {
      selector: '.nav-user-profile',
      title: 'Profile & Settings',
      description: 'Access your profile settings, notifications, and restart this tour anytime.',
      position: 'right',
      highlightPadding: 6,
      disableLeftBackdrop: true,
      noLeftOffset: true,
      requiredSection: null
    }
  ],

  client: [
    {
      selector: '[data-section="dashboard"]',
      title: 'Welcome to Velvet',
      description: 'Your content overview - see upcoming posts, recent activity, and key insights about your brand.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'dashboard'
    },
    {
      selector: '[data-onboarding="org-brand-selector"]',
      title: 'Organization & Brand Selector',
      description: 'Click here to switch between your organizations and brands. This controls which content you see and manage.',
      position: 'right',
      highlightPadding: 6,
      requiredSection: null
    },
    {
      selector: '[data-section="content"]',
      title: 'Content Hub',
      description: 'Your main hub for reviewing and managing content. This is where you approve or request changes.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: null,
      expandAccordion: true
    },
    {
      selector: '[data-section="review-content"]',
      title: 'Review Content',
      description: 'Review content drafts, approve them, or request changes from your content team.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'review-content',
      parentAccordion: '[data-section="content"]'
    },
    {
      selector: '[data-section="ideas"]',
      title: 'Content Ideas',
      description: 'See what content ideas are being developed for your brand.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: null,
      expandAccordion: true
    },
    {
      selector: '[data-section="operator-review-ideas"], [data-section="client-review-ideas"]',
      title: 'Review Ideas',
      description: 'Review and provide feedback on content ideas before they become full drafts.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: null,
      parentAccordion: '[data-section="ideas"]'
    },
    {
      selector: '[data-section="brand-hub"]',
      title: 'Brand Hub',
      description: 'Define and manage your brand identity. This is where you shape your brand voice.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: null,
      expandAccordion: true
    },
    {
      selector: '[data-section="brand-builder"]',
      title: 'Brand Voice Designer',
      description: 'Create your brand voice and personality. This ensures all content matches your unique style.',
      position: 'right',
      highlightPadding: 4,
      requiredSection: 'brand-builder',
      parentAccordion: '[data-section="brand-hub"]'
    },
    {
      selector: '.nav-user-profile',
      title: 'Profile & Settings',
      description: 'Access your account settings, notifications, and restart this onboarding tour anytime.',
      position: 'right',
      highlightPadding: 6,
      disableLeftBackdrop: true,
      noLeftOffset: true,
      requiredSection: null
    }
  ]
};

export default onboardingSteps;
